<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <RichContent
      class="field-value"
      :content="formattedValue"
    />
  </div>
</template>

<script>
import RichContent from '@/components/RichContent'

export default {
  components: { RichContent },
  props: {
    value: {
      type: String,
      default: '-',
    },
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedValue() {
      if (
        this.value === null ||
        this.value === undefined ||
        this.value === '' ||
        this.value === '-'
      )
        return this.emptyValuePlaceholder
      else return this.value
    },
    emptyValuePlaceholder() {
      return this.question?.config?.default?.value || '-'
    },
  },
}
</script>
